import { Component, Input } from '@angular/core';

export type HealthState = 'good' | 'warning' | 'critical';

@Component({
  selector: 'app-kiln-health-visual',
  templateUrl: './kiln-health-visual.component.html',
  styleUrls: ['./kiln-health-visual.component.scss']
})
export class KilnHealthVisualComponent {
  @Input() zoneStates: HealthState[] = ['good', 'good', 'good'];
  @Input() controllerState: HealthState = 'good';
  @Input() outletState: HealthState = 'good';
  @Input() clockState: HealthState = 'good';

  getZoneState(index: number): HealthState {
    return this.zoneStates[index] || 'good';
  }

  getZoneTooltip(index: number): string {
    const labels = ['Top heating zone', 'Middle heating zone', 'Bottom heating zone'];
    return `${labels[index] || 'Heating zone'}: ${this.describeState(this.getZoneState(index))}`;
  }

  getControllerTooltip(): string {
    return `Controller output status: ${this.describeState(this.controllerState)}`;
  }

  getClockTooltip(): string {
    return `Firing/timing indicator: ${this.describeState(this.clockState)}`;
  }

  getOutletTooltip(): string {
    return `Power outlet and incoming supply: ${this.describeState(this.outletState)}`;
  }

  getThermocoupleTooltip(): string {
    return 'Thermocouple lead to controller input (temperature sensing path)';
  }

  private describeState(state: HealthState): string {
    if (state === 'good') {
      return 'normal';
    }
    if (state === 'warning') {
      return 'warning - inspect';
    }
    return 'critical - action needed';
  }
}
